import { Navigate } from 'react-router-dom';
const CustomerDashboard = () => <Navigate to="/customer/orders" replace />;
export default CustomerDashboard;
